import React from 'react';
import { Modal } from 'antd';
import classnames from 'classnames';
import styles from '../mailInfo.module.scss';
import IconCard from '@web-common/components/UI/IconCard/index';
import ConferenceSetting from './Setting';
import ConferenceDesc from './ConferenceDesc';
import { MailActions, useAppSelector, useActions } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
import { remWaittingId } from '@web-mail-write/util';
export const conferenceWrapClassName = styles.conferenceWrap;
const Conference = props => {
    const { status: infoStatus, conference, id } = useAppSelector(state => state.mailReducer.currentMail);
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const mailActions = useActions(MailActions);
    const conferenceShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.conferenceShow;
    const conferenceSetting = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.conferenceSetting;
    const deleteConfConfirm = async () => {
        mailActions.doShowUserBusyFree(false);
        mailActions.doConferenceShow(false);
        mailActions.doConferenceSettting(false);
        mailActions.doConferenceChange(undefined);
    };
    const deleteConf = e => {
        e.stopPropagation();
        remWaittingId(currentMailId, true);
        Modal.confirm({
            okButtonProps: { danger: true, type: 'default' },
            title: getIn18Text('QUEDINGSHANCHUHUI'),
            okText: getIn18Text('SHANCHU'),
            cancelText: getIn18Text('QUXIAO'),
            onOk: deleteConfConfirm,
            width: 448,
            className: 'im-team',
            centered: true,
        });
    };
    const showSetting = () => {
        mailActions.doConferenceSettting(true);
    };
    const set = conferenceShow ? (React.createElement("div", { className: classnames([styles.infoItem]), onClick: showSetting },
        React.createElement("span", { className: styles.infoLabel }, getIn18Text('HUIYI')),
        React.createElement("span", { className: styles.colonLabel }, ":"),
        React.createElement("div", { className: classnames([styles.conferenceTime, styles.conferenceTimeDesc]) },
            React.createElement(ConferenceDesc, null)),
        React.createElement("div", { className: classnames([styles.btnBox, styles.closeBtn]) },
            React.createElement("span", { className: classnames([styles.labelBtn, styles.labelCloseBtn]), onClick: deleteConf },
                React.createElement(IconCard, { className: "dark-invert", type: "close" }))))) : null;
    return (React.createElement("div", { className: conferenceWrapClassName, style: { height: conferenceShow ? 'auto' : 0 } },
        React.createElement("div", { hidden: !conferenceSetting }, conference && React.createElement(ConferenceSetting, Object.assign({ key: id, deleteConf: deleteConf }, props))),
        React.createElement("div", { hidden: conferenceSetting }, set)));
};
export default Conference;
